import { post,postRequest, getRequest, deleteRequest } from '@/utils/axios'

// 查询翻页
export function GetInsureList(query) {
    return post('/insure/GetInsureList', query)
  }

//根据类型查询不同的保险接口
export function GetInsure(query) {
    var url = ''
    switch(query.itype){
        case '4':
            url = "/insure-bidsecurity/GetInsureList"   //投标保证保险
        break
        case '5':
            url = "/insure-contract-performance/GetInsureList"   //合同履约保证保险
        break
        case '6':
            url = "/insure-project-payment/GetInsureList"  //工程款支付保证保险
        break
        case '7':
            url = "/insure-migrant-workers/GetInsureList"  //农民工工资支付保证保险
        break
        case '8':
            url = "/insure-construction-quality/GetInsureList"  //工程质量保证保险
        break
        case '9':
            url = "/insure-prepayments/GetInsureList"  //预付款保证保险
        break
        case '20':
            url = "/insure-conengin-group-acc-insur/GetInsureList"  //建筑工程团体意外伤害保险
        break
        case '21':
            url = "/insure-empliabinsurcon-enterprises/GetInsureList"  //建筑施工企业雇主责任保险
        break
        case '22':
            url = "/insure-constr-all-risks-insurance/GetInsureList"  //建筑工程一切险
        break
        case '23':
            url = "/insure-install-all-risk-insurance/GetInsureInstallAllRiskInsurance"   //安装工程一切险
        break
    }
    return post(url,query)
}


//查看理赔报告
export function GetVInsure(query) {
    var url = ''
    switch(query.itype.toString()){
        case '4':
            url = "/insure-bidsecurity/GetVInsureBidsecurity"   //投标保证保险
        break
        case '5':
            url = "/insure-contract-performance/GetVInsuresContractPerformance"   //合同履约保证保险
        break
        case '6':
            url = "/insure-project-payment/GetVInsureProjectPayment"  //工程款支付保证保险
        break
        case '7':
            url = "/insure-migrant-workers/GetVInsureMigrantWorkers"  //农民工工资支付保证保险
        break
        case '8':
            url = "/insure-construction-quality/GetVInsureConstructionQuality"  //工程质量保证保险
        break
        case '9':
            url = "/insure-prepayments/GetVInsurePrepayments"  //预付款保证保险
        break
        case '20':
            url = "/insure-conengin-group-acc-insur/GetVInsureConenginGroupAcc"  //建筑工程团体意外伤害保险
        break
        case '21':
            url = "/insure-empliabinsurcon-enterprises/GetVInsureEmpliabinsurconEnterprises"  //建筑施工企业雇主责任保险
        break
        case '22':
            url = "/insure-constr-all-risks-insurance/GetVInsureConstrAllRisksInsurance"  //建筑工程一切险
        break
        case '23':
            url = "/insure-install-all-risk-insurance/GetVInsureInstallAllRiskInsurance"   //安装工程一切险
        break
    }
    return post(url,query)
}
 
//4 跳转投标保证保险  
export function GetISBidDoc(query) {
    return post('/insure-bidsecurity/GetISBidDoc',query)
}


//删除
export function deleteWindow(query) {
    // console.log(query.uuid,777777)
    var url = ''
    switch(query.itype.toString()){
        case '4':
        url = `/insure-bidsecurity/delByIds/${query.uuid}`  //4 投标保证保险
        break
        case '5':
        url = `/insure-contract-performance/delByIds/${query.uuid}`  //5 删除合同履约保证保险
        break
        case '6':
        url = `/insure-project-payment/delByIds/${query.uuid}`   //6 删除工程款支付保证保险
        break
        case '7':
        url = `/insure-migrant-workers/delByIds/${query.uuid}`   //7 删除农民工工资支付保证保险
        break
        case '8':
            url = `/insure-construction-quality/delByIds/${query.uuid}`   //工程质量保证保险
        break
        case '9':
            url = `/insure-prepayments/delByIds/${query.uuid}` //预付款保证保险
        break
        case '20':
            url = `/insure-conengin-group-acc-insur/delByIds/${query.uuid}` //建筑工程团体意外伤害保险
        break
        case '21':
            url = `/insure-empliabinsurcon-enterprises/delByIds/${query.uuid}` //建筑施工企业雇主责任保险
        break
        case '22':
            url = `/insure-constr-all-risks-insurance/delByIds/${query.uuid}`  //建筑工程一切险
        break
        case '23': 
            url = `/insure-install-all-risk-insurance/delByIds/${query.uuid}` //安装工程一切险
        break
    }
    return deleteRequest(url)
}

//凭证上传
export function UpPayVoucher(query){
    var url = ''
    switch(query.itype.toString()){
        case '4':
        url = "/insure-bidsecurity/UpPayVoucherInsureBidsecurity"  //4 投标保证保险
        break
        case '5':
        url = "/insure-contract-performance/UpPayVoucherInsureContractPerformance"  //5 上传合同履约保证保险
        break
        case '6':
        url = "/insure-project-payment/UpPayVoucherInsureProjectPayment"   //6 上传工程款支付保证保险
        break
        case '7':
        url = "/insure-migrant-workers/UpPayVoucherInsureMigrantWorkers"   //7 上传农民工工资支付保证保险
        break
        case '8':
            url = "/insure-construction-quality/UpPayVoucherInsuresConstructionQuality"   //工程质量保证保险
        break
        case '9':
            url = "/insure-prepayments/UpPayVoucherInsurePrepayments" //预付款保证保险
        break
        case '20':
            url = "/insure-conengin-group-acc-insur/UpPayVoucherInsureConenginGroupAccInsur" //建筑工程团体意外伤害保险
        break
        case '21':
            url = "/insure-empliabinsurcon-enterprises/UpPayVoucherInsureEmpliabinsurconEnterprises" //建筑施工企业雇主责任保险
        break
        case '22':
            url = "/insure-constr-all-risks-insurance/UpPayVoucherInsureConstrAllRisksInsurance"  //建筑工程一切险
        break
        case '23': 
            url = "/insure-install-all-risk-insurance/UpPayVoucherInsureInstallAllRiskInsurance" //安装工程一切险
        break
    }
    return post(url,query)
}

//根据类型查询不同的不分页保险接口
export function GetVInsureData(query) {
    var url = ''
    switch(query.itype){
        case '4':
            url = "/insure-bidsecurity/GetVInsuresBidsecurity"   //投标保证保险
        break
        case '5':
            url = "/insure-contract-performance/GetVInsureContractPerformance"   //合同履约保证保险
        break
        case '6':
            url = "/insure-project-payment/GetVInsuresInsureProjectPayment"  //工程款支付保证保险
        break
        case '7':
            url = "/insure-migrant-workers/GetVInsuresMigrantWorkers"  //农民工工资支付保证保险
        break
        case '8':
            url = "/insure-construction-quality/GetVInsuresConstructionQuality"  //工程质量保证保险
        break
        case '9':
            url = "/insure-prepayments/GetVInsuresPrepayments"  //预付款保证保险
        break
        case '20':
            url = "/insure-conengin-group-acc-insur/GetVInsuresConenginGroupAccInsur"  //建筑工程团体意外伤害保险
        break
        case '21':
            url = "/insure-empliabinsurcon-enterprises/GetVInsuresEmpliabinsurconEnterprises"  //建筑施工企业雇主责任保险
        break
        case '22':
            url = "/insure-constr-all-risks-insurance/GetVInsuresConstrAllRisksInsurance"  //建筑工程一切险
        break
        case '23':
            url = "/insure-install-all-risk-insurance/GetVInsuresInstallAllRiskInsurance"   //安装工程一切险
        break
    }
    return post(url,query)
}

//校验code码
export function GetInsureCode(query){
    return post('/InsureController/GetInsureCode',query)
}


export function giveUpInsure(query){
    return post('/insure/giveUpInsure',query)
}

//查询单个保单
export function GetInsureOne(query){
    return post('/insure/GetInsureOne',query)
}

//查询单个保单
export function GetInsureOneNotCode(query){
    return post('/insure/GetInsureOneNotCode',query)
}

//查询农民工单个保单
export function GetInsureInsureMigrantWorkers(query){
    return post('/insure-migrant-workers/GetInsureInsureMigrantWorkers',query)
}

// 点击查询单个保单
export function GetInsureBidsecurity(query) {
    return post('/insure-bidsecurity/GetInsureBidsecurity', query)
  }

  // 点击查询单个保单的全部信息
export function GetInsureBidsecurityAll(query) {
    return post('/insure-bidsecurity/GetInsureBidsecurityAll', query)
  }
  
// 投标退保
export function ReturnBond(query) {
  return post('/PayInsureController/ReturnBond', query)
}
// 查询公司信息
export function getCompany(query) {
  return post('/company/selectCompany', query)
}
// 申请发票
export function applyforInvoice(query) {
    return post('/company/applyforInvoice', query)
}
  
  


// WEBPACK FOOTER //
// ./src/api/insure.js